export const MULTISELECT_SLOT_FALLBACK_CSS = `
[data-incase-slot="multiselect"] .c-questionLayout {
  display: flex;
  flex-direction: column;
  gap: 0.75em;
  box-sizing: border-box;
  width: 100%;
  font: inherit;
  color: inherit;
  background: transparent;
}
[data-incase-slot="multiselect"] .c-questionLayout__body,
[data-incase-slot="multiselect"] .c-multiSelectElement {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  width: 100%;
}
[data-incase-slot="multiselect"] .c-questionTitle,
[data-incase-slot="multiselect"] .c-button,
[data-incase-slot="multiselect"] .c-button__content {
  font: inherit;
  color: inherit;
}
[data-incase-slot="multiselect"] .c-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 0.25em;
  padding: 0.5em 0.75em;
  text-align: left;
  box-sizing: border-box;
  cursor: pointer;
}
[data-incase-slot="multiselect"] .c-button--align-left {
  justify-content: flex-start;
}
[data-incase-slot="multiselect"] .c-button__leading {
  flex-shrink: 0;
}
[data-incase-slot="multiselect"] .c-questionElement__answer {
  position: relative;
}
[data-incase-slot="multiselect"] .c-questionElement__answer_comment {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(30%, -30%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(26px * var(--answer-comment-scale, 1));
  height: calc(26px * var(--answer-comment-scale, 1));
  font-size: calc(22px * var(--answer-comment-scale, 1));
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
  color: inherit;
}
[data-incase-slot="multiselect"] .c-questionElement__answer_comment svg {
  color: inherit;
  fill: currentColor;
}
[data-incase-slot="multiselect"] .c-button--color-info + .c-questionElement__answer_comment svg {
  color: #589ec5;
}
[data-incase-slot="multiselect"] .c-button--color-success + .c-questionElement__answer_comment svg {
  color: #48c774;
}
[data-incase-slot="multiselect"] .c-button--color-error + .c-questionElement__answer_comment svg {
  color: #da2c38;
}
[data-incase-slot="multiselect"] .c-button--color-warning + .c-questionElement__answer_comment svg {
  color: #cc7722;
}
[data-incase-slot="multiselect"] .c-questionElement__answer_comment::before {
  content: "";
  position: absolute;
  inset: calc(-10px * var(--answer-comment-scale, 1));
  cursor: pointer;
}
[data-incase-slot="multiselect"] [aria-live] {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
[data-incase-slot="multiselect"] .c-multiSelectElement__select {
  position: relative;
  width: 100%;
}
[data-incase-slot="multiselect"] .c-multiSelectElement__select::before {
  content: "";
  position: absolute;
  z-index: 1;
  right: 1em;
  top: calc(2.375em / 2);
  width: 0.45em;
  height: 0.45em;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: translateY(-70%) rotate(45deg);
  pointer-events: none;
}
[data-incase-slot="multiselect"] .c-multiSelect__indicators {
  display: none;
}
[data-incase-slot="multiselect"] .c-multiSelectElement__select .c-multiSelect__control {
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 0.5em;
  min-height: 2.375em;
  box-shadow: none;
  cursor: pointer;
  font: inherit;
  color: inherit;
}
[data-incase-slot="multiselect"] .c-multiSelectElement__select .c-multiSelect__placeholder,
[data-incase-slot="multiselect"] .c-multiSelectElement__select .c-multiSelect__input,
[data-incase-slot="multiselect"] .c-multiSelectElement__select .c-multiSelect__single-value,
[data-incase-slot="multiselect"] .c-multiSelectElement__valueSelected {
  font: inherit;
  color: inherit;
}
[data-incase-slot="multiselect"] .c-multiSelectElement__valueAnswered_correct {
  color: var(--incase-correct, currentColor);
}
[data-incase-slot="multiselect"] .c-multiSelectElement__valueAnswered_incorrect {
  color: var(--incase-incorrect, currentColor);
}
[data-incase-slot="multiselect"] .c-multiSelectElement__valueAnswered_debatable {
  color: var(--incase-accent, currentColor);
}
`;

export function injectMultiselectSlotFallback(doc: Document): void {
    if (
        !doc.head ||
        !doc.querySelector('[data-incase-slot="multiselect"]') ||
        doc.head.querySelector('style[data-incase-fallback="multiselect"]')
    ) {
        return;
    }

    const style = doc.createElement('style');
    style.setAttribute('data-incase-fallback', 'multiselect');
    style.textContent = MULTISELECT_SLOT_FALLBACK_CSS;
    doc.head.insertBefore(style, doc.head.firstChild);
}
